import { render } from "./KindergartenHeadView.vue?vue&type=template&id=655ba6ac&scoped=true&ts=true"
import script from "./KindergartenHeadView.vue?vue&type=script&lang=ts"
export * from "./KindergartenHeadView.vue?vue&type=script&lang=ts"

import "./KindergartenHeadView.vue?vue&type=style&index=0&id=655ba6ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655ba6ac"]])

export default __exports__